export const showOrederBlockMessage = (arr) => {
  const message = document.querySelector('.order-block__message');

  if (!message) {
    return;
  }

  if (arr.length == 0) {
    message.classList.add('order-block__message--show');
  } else {
    message.classList.remove('order-block__message--show');
  }
}

export const showOrederBlockLink = (arr) => {
  const link = document.querySelector('.order-block__link');

  if (!link) {
    return;
  }

  if (arr.length == 0) {
    link.classList.add('order-block__link--show');
  } else {
    link.classList.remove('order-block__link--show');
  }
}